import { List, SimpleGrid } from '@chakra-ui/react';

import PostItemCard from '@/components/Card/PostItemCard';

import RoutePath from '@/constants/route-path';
import { OpportunityProps } from '@/models/props/OpportunitiesProps';
import { StrapiUtilsService } from '@/services/StrapiUtilsService';

type PostsProps = {
    opportunities: OpportunityProps[];
};

function PostsGrid(props: PostsProps) {
    const { opportunities } = props;

    return (
        <SimpleGrid
            as={List}
            columns={{
                base: 1,
                sm: 2,
                lg: 3,
                '2xl': 4
            }}
            gap={4}
        >
            {opportunities.map((item) => {
                const imageUrl = item.attributes.quicklook?.data?.[0].attributes.url;
                const image = imageUrl && StrapiUtilsService.updateUploadsUrl(imageUrl);

                return (
                    <PostItemCard
                        key={item.id}
                        title={item.attributes.title}
                        shortDescription={item.attributes.shortDescription}
                        url={`${RoutePath.Opportunities}/${item.attributes.slug || ''}`}
                        imageUrl={image}
                        imageAlt={
                            item.attributes.quicklook?.data?.[0].attributes?.alternativeText ||
                            item.attributes.title
                        }
                    />
                );
            })}
        </SimpleGrid>
    );
}

export default PostsGrid;
